
import { defineComponent, ref } from 'vue';
import recordVue from '@/components/report/record.vue';
import scoreVue from '@/components/report/score.vue';
import userInfoVue from '@/components/report/userInfo.vue';
import backHeaderVue from '@/components/ui/backHeader/index.vue';
import { Uuid } from '@/lib/index';
import useReportHooks, { Component } from '@/hooks/report.hooks';
import { useRoute, useRouter } from 'vue-router';
import print from 'vue3-print-nb';
import { Button } from 'ant-design-vue';
import ManagementFrame from '@/components/ui/managementFrame/index.vue';
import SvgIcon from '@/components/SvgIcon.vue';
import '@/assets/icons/back.svg';

export default defineComponent({
  directives: {
    print,
  },
  components: {
    recordVue,
    scoreVue,
    userInfoVue,
    backHeaderVue,
    aButton: Button,
    ManagementFrame,
    SvgIcon,
  },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const reportHooks = useReportHooks();
    const componentList = ref<Uuid<Component>[]>([]);
    const printObj = {
      id: 'm-body',
      popTitle: '实验报告',
    };

    const init = async () => {
      //
      // const comData = await reportHooks.getExperimentReport('c67c4156-04b4-4156-9a7b-32de5a5308ea', 'lwj');
      const comData = await reportHooks.getExperimentReport(route.params.experimentId as string, route.params.userId as string);
      componentList.value = reportHooks.setComponentData(reportHooks.getReportComponents(), comData);
    };

    init();
    const back = () => {
      router.back();
    };
    return {
      componentList,
      back,
      printObj,
      experimentName: reportHooks.currentReportExperimentName.get(),
    };
  },
});
